/* eslint-disable new-cap */
/* eslint-disable sort-keys */
/* eslint-disable max-lines-per-function */
import 'extensions/ui-components/x-input-mask';
import {FormElementMixin} from 'extensions/ui-mixins/form-element/lib/form-element-mixin';
import {defineCustomElement, isPoBox} from 'extensions/ui-utils';
import {LitElement, html} from 'lit';
import stylesheet from './x-address-form.scss?as=stylesheet';

export class AddressForm extends FormElementMixin(LitElement) {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			allowOtherState: {
				attribute: 'allow-other-state',
				type: Boolean
			},
			fname: {
				type: String
			},
			lname: {
				type: String
			},
			email: {
				type: String
			},
			comp: {
				type: String
			},
			phone: {
				type: String
			},
			fax: {
				type: String
			},
			addr1: {
				type: String
			},
			addr2: {
				type: String
			},
			city: {
				type: String
			},
			state: {
				type: String
			},
			zip: {
				type: String
			},
			cntry: {
				type: String
			}
		};
	}

	get fullName () {
		return `${this.fname} ${this.lname}`.trim();
	}

	constructor () {
		super();

		/**
		 * @type {import('extensions/ui-components/types').MivaState[]}
		 */
		this._stateList = window.mivaJS?.State_List;

		/**
		 * @type {boolean}
		 */
		this.allowOtherState = false;

		/**
		 * @type {string}
		 */
		this.fname = '';

		/**
		 * @type {string}
		 */
		this.lname = '';

		/**
		 * @type {string}
		 */
		this.email = '';

		/**
		 * @type {string}
		 */
		this.comp = '';

		/**
		 * @type {string}
		 */
		this.phone = '';

		/**
		 * @type {string}
		 */
		this.fax = '';

		/**
		 * @type {string}
		 */
		this.addr1 = '';

		/**
		 * @type {string}
		 */
		this.addr2 = '';

		/**
		 * @type {string}
		 */
		this.city = '';

		/**
		 * @type {string}
		 */
		this.state = '';

		/**
		 * @type {string}
		 */
		this.zip = '';

		/**
		 * @type {string}
		 */
		this.cntry = '';
	}

	/**
	 * @param {InputEvent} e
	 */
	handleAddress1Change (e) {
		if (isPoBox(e.target.value)) {
			e.target.setCustomValidity('PO Boxes are not allowed here.');
			e.target.reportValidity();
		}
	}

	renderStateInput () {
		if (this.allowOtherState && this._stateList?.every(state => state.code !== this.state)) {
			return html`<input type="text" name="state" id="state" class="c-form-input c-form-input--large" .value="${this.state}" required />`;
		}

		return html`
			<div class="c-form-select">
				<select name="state" id="state" class="c-form-select__dropdown c-form-input--large" required>
					${this._stateList?.map(state => html`<option .value="${state.code}" .selected="${state.code === this.state}">${state.prompt}</option>`)}
				</select>
			</div>
		`;
	}

	renderInnerForm () {
		return html`
			<div class="c-form-list o-layout">
				<div class="c-form-list__item o-layout__item u-width-12 u-width-6--m form_row">
					<label class="c-form-label u-text-bold is-required" for="l-name">Name</label>
					<input id="l-name" class="c-form-input c-form-input--large" type="text" name="name" .value="${this.fullName}" maxlength="50" required />
				</div>
				<div class="c-form-list__item o-layout__item u-width-12 u-width-6--m form_row" hidden>
					<label class="c-form-label u-text-bold" for="l-comp">Company Name</label>
					<input id="l-comp" class="c-form-input c-form-input--large" type="text" name="comp" .value="${this.comp}" maxlength="50" />
				</div>
				<div class="c-form-list__item o-layout__item u-width-12 u-width-6--m form_row">
					<label class="c-form-label u-text-bold is-required" for="l-email">Email Address</label>
					<input id="l-email" class="c-form-input c-form-input--large" type="text" name="email" .value="${this.email}" inputmode="email" maxlength="254" required />
				</div>
				<div class="c-form-list__item o-layout__item u-width-12 u-width-6--m form_row">
					<label class="c-form-label u-text-bold is-required" for="l-phone">Phone Number</label>
					<x-input-mask .value="${this.phone}" mask="00 00000000">
						<input
							id="l-phone"
							class="c-form-input
							c-form-input--large"
							type="text"
							name="phone"
							maxlength="50"
							inputmode="tel"
							required />
					</x-input-mask>
				</div>
				<div class="c-form-list__item o-layout__item u-width-12 u-width-6--m form_row">
					<label class="c-form-label u-text-bold" for="l-fax">Mobile Number</label>
					<x-input-mask .value="${this.fax}" mask="0000000000000">
						<input id="l-fax" class="c-form-input c-form-input--large" type="text" name="fax" maxlength="50" inputmode="text" />
					</x-input-mask>
				</div>
				<div class="c-form-list__item o-layout__item u-width-12 u-width-6--m form_row">
					<label class="c-form-label u-text-bold is-required" for="l-addr1">Address</label>
					<input id="l-addr1" class="c-form-input c-form-input--large" type="text" name="addr1" .value="${this.addr1}" maxlength="100" required @change="${this.handleAddress1Change}" />
				</div>
				<div class="c-form-list__item o-layout__item u-width-12 u-width-6--m form_row">
					<label class="c-form-label u-text-bold" for="l-addr2">Address 2</label>
					<input id="l-addr2" class="c-form-input c-form-input--large" type="text" name="addr2" .value="${this.addr2}" maxlength="100" />
				</div>
				<div class="c-form-list__item o-layout__item u-width-12 u-width-6--m form_row">
					<label class="c-form-label u-text-bold is-required" for="l-city">Suburb</label>
					<input id="l-city" class="c-form-input c-form-input--large" type="text" name="city" .value="${this.city}" maxlength="50" required />
				</div>
				<div class="c-form-list__item o-layout__item u-width-12 u-width-6--m form_row">
					<label class="c-form-label u-text-bold is-required" for="state">State/Territory</label>
					${this.renderStateInput()}
				</div>
				<div class="c-form-list__item o-layout__item u-width-12 u-width-6--m form_row">
					<label class="c-form-label u-text-bold is-required" for="cntry">Country</label>
					<div class="c-form-select">
						<select id="cntry" disabled class="c-form-select__dropdown c-form-input--large">
							<option value="NZL" name="cntry" selected>New Zealand</option>
						</select>
						<input type="hidden" name="cntry" value="NZL" />
					</div>
				</div>
				<div class="c-form-list__item o-layout__item u-width-12 u-width-6--m form_row">
					<label class="c-form-label u-text-bold is-required" for="l-zip">Postcode</label>
					<x-input-mask .value="${this.zip}" mask="0000">
						<input id="l-zip" class="c-form-input c-form-input--large" type="text" name="zip" data-mask="0000" inputmode="number" required />
					</x-input-mask>
				</div>
			</div>

			<button hidden>Use Address</button>
		`;
	}
};

defineCustomElement('x-address-form', AddressForm);
